import { Hexagon } from "lucide-react";

const ITEMS = [
  "99.8% HPLC PURITY VERIFIED",
  "BIO-AVAILABLE CELLULAR OPTIMIZATION",
  "THIRD-PARTY LAB CERTIFIED",
  "ADVANCED PEPTIDE THERAPEUTICS",
  "MOLECULAR PRECISION FORMULATIONS",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative overflow-hidden border-y border-white/5 bg-[#0C0C0F] py-5" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10">
                <span className="font-mono text-xs tracking-[0.3em] text-slate-400">{item}</span>
                <Hexagon className="h-3 w-3 text-[#E8E9EB]" strokeWidth={1.5} />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
